import { TextLink } from '@vds/buttons';
import { Row } from '@vds/grids';
import TravelPass from '@vds/icons/travel-pass';
import { Line } from '@vds/lines';
import { Notification } from '@vds/notifications';
import { Body, Title } from '@vds/typography';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { convertStringToElements } from '@vds/html-parsers';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import AdvisoryDetails from '../../shared/components/AdvisoryDetails';
import Billchange from '../../shared/components/Billchange';
import ConnectedDeviceDetails from '../../shared/components/ConnectedDeviceDetails';
import DeviceDetails from '../../shared/components/DeviceDetails';
import ErrorPage from '../../shared/components/ErrorPage';
import Footer from '../../shared/components/Footer';
import Header from '../../shared/components/Header';
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, nsaUnauthToAuthFlowEnableFFlag, isACSS, isPOS, nsaItpAcssPosFlowEnablementFFlag, isNative, SessionIdGlobal, sessionIdMatchFixFFlag, unauth } from '../../shared/utils/globalConfig';
import { addSpace,getDestList } from '../../shared/utils/globalUtils';
import { dispatchNotifyEvent, setCurrentPlanDetails,dispatchDeviceAndPlansImpression } from '../../shared/utils/tagging'
import { setRetainDatesAndDestinations,setConfirmationPage, setDevicesPlansAPIFetch,setUnauthToAuth, saveSelectedDestinations } from '../../features/selectedData/selectedDataReducer';
import Cookies from 'js-cookie';
import { savePersistantDestinations,saveDeviceDetails,savePersistantDates,clearConfirmedPlanData,saveDevicesAndPlansPayload } from '../../features/selectedData/persistantDataReducer';
import Reptool from '../../shared/components/Reptool';
import WrapUp from '../../shared/components/wrapUp';
import {  nativeSetTitleOnly } from '../../shared/utils/native';




const DevicePageMain = styled.div`
`
const StyledRow = styled(Row)`

`;

const DevicePage = styled.div`

`
const Space = styled.div`
padding-top: ${props => props.pt || 12}px;
`
const StyledBlock = styled.div`
display: flex;
gap: 3px;
p {
min-width: 75px;
}
`

const StyledTextDiv = styled.div`
display:flex;
gap:2px;
width:${isDesktop ? '500px' : ''};
align-items: center;
`
const fetchValue = (sessionIdVar) => {
    return( (sessionIdVar === SessionIdGlobal)? false : true)
       
   }

export default function DevicesAndPlans() {
    const previousLocation = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const yourTripRef = useRef(null);
    const { selectedDestinations, selectedDates, confirmedPlanData } = useSelector(state => state?.persistantReducer);
    const { failedUpdateCartData, devicesPlansAPIFetch,unauthToAuth, sessionIdVar } = useSelector(state => state?.selectedReducer);
    const { loadConfirmPage } = useSelector(state => state?.selectedReducer);
    const unAuthSessionId = Cookies.get('NsaUnAuthSessionId');


    let isSesIdNotMatched =  false;
    if(sessionIdMatchFixFFlag && !unauth){
        isSesIdNotMatched = fetchValue(sessionIdVar);}
    useEffect(() => {
        if (sessionIdMatchFixFFlag && isSesIdNotMatched && !unauth) {
            dispatch(saveSelectedDestinations([]));
            dispatch(savePersistantDestinations([]));
            dispatch(savePersistantDates({}));
            navigate('/', { replace: true })
        }
    }, [])
    useEffect(() => {
        if ((selectedDestinations && selectedDestinations.length === 0 || 
            selectedDates.travelStartDate ==undefined && selectedDates.travelEndDate ==undefined) && !unAuthSessionId) {
            navigate('/', { replace: true })
        }

    }, [selectedDestinations])

    useEffect(() => {
        setTimeout(() => {
        if (yourTripRef.current) {
            triggerClick();
        }
    }, 200)
      
    });
    const triggerClick = () => {
        console.log("Your trip clicked");
      };

    const getDevicesPayload = () => {
        const payload = {
            'destinationSelected': unAuthSessionId && unAuthSessionId !== undefined && nsaUnauthToAuthFlowEnableFFlag ? [] : getDestList(selectedDestinations, 'key'),
            "travelStartDate": unAuthSessionId && unAuthSessionId !== undefined && nsaUnauthToAuthFlowEnableFFlag ? '' : selectedDates?.travelStartDate,
            "travelEndDate": unAuthSessionId && unAuthSessionId !== undefined && nsaUnauthToAuthFlowEnableFFlag ? '' : selectedDates?.travelEndDate,
            "unAuthSessionId": unAuthSessionId && unAuthSessionId !== undefined && nsaUnauthToAuthFlowEnableFFlag ? unAuthSessionId : ''
        }
        return payload;
    }


    const { data, error, isLoading, isSuccess } = useGetDevicesAndPlansByNameQuery(getDevicesPayload(),
    {skip: ((selectedDestinations && selectedDestinations.length === 0 ||
    selectedDates?.travelStartDate ==undefined && selectedDates?.travelEndDate ==undefined) 
    && !unAuthSessionId) || unauthToAuth || isSesIdNotMatched},
    { refetchOnMountOrArgChange: devicesPlansAPIFetch });

  
    const [deviceSelectionData, setDeviceSelectionData] = useState();
    const [flightReviewDetailObject, setFlightReviewDetailObject] = useState();
    const [pendingOrderObject, setPendingOrderObject] = useState();
    const [wrapUpData,setWrapUpData] = useState();

    useEffect(() => {
        if(data!=undefined){
        setDeviceSelectionData(data?.body?.data?.devicesAndPlans)
        setPendingOrderObject(data?.body?.data?.pendingOrder)
        setFlightReviewDetailObject(data?.body?.data?.inFlightReviewDetailObject)
        setWrapUpData(data?.body?.data?.wrapUpRepTool)
        if(selectedDestinations && selectedDestinations.length !== 0)
        {dispatch(setRetainDatesAndDestinations(true));}
        if(devicesPlansAPIFetch) {
            dispatch(setDevicesPlansAPIFetch(false))
        }}
    }, [data]);


    // for unauth to auth flow to retain the dates and destinations from device response and also to clear the confirmedplandata
    useEffect(() => {
        if (data!=undefined && unAuthSessionId && unAuthSessionId !== undefined && selectedDestinations.length==0 && nsaUnauthToAuthFlowEnableFFlag) {
            if(data?.body?.data?.devicesAndPlans?.selectedDestinations)
            dispatch(savePersistantDestinations((data?.body?.data?.devicesAndPlans?.selectedDestinations)));
            if(data?.body?.data?.devicesAndPlans?.selectedDates){
           dispatch(savePersistantDates(data?.body?.data?.devicesAndPlans?.selectedDates));}
           dispatch(clearConfirmedPlanData());
           dispatch(setRetainDatesAndDestinations(true));
           dispatch(setUnauthToAuth(true))
           Cookies.remove('NsaUnAuthSessionId');
        }
    }, [data]);

    //to save devices payload 
    useEffect(()=>{
        if(nsaUnauthToAuthFlowEnableFFlag)
        dispatch(saveDevicesAndPlansPayload(getDevicesPayload()))
    },[data])

    

    //Tagging
    useEffect(() => {

        if (deviceSelectionData?.notification) {
            dispatchNotifyEvent(deviceSelectionData?.notification?.text)
        }
        if (deviceSelectionData?.onlyAirPlane && deviceSelectionData?.airplaneNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.airplaneNotificationText, "99")
        }
        if (deviceSelectionData?.payGoOnly && deviceSelectionData?.payGoOnlyNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.payGoOnlyNotificationText, "99")
        }
        if (deviceSelectionData?.mixedPayGo && deviceSelectionData?.mixedPayGoNotificationText) {
            dispatchNotifyEvent(deviceSelectionData?.mixedPayGoNotificationText)
        }
        if(deviceSelectionData?.deviceDetails)
            setCurrentPlanDetails(deviceSelectionData?.deviceDetails,"#device_page");
        
    }, [deviceSelectionData])

   

    useEffect(() => {
        window.scrollTo(0, 0);
        if(isNative){
            nativeSetTitleOnly("International Plans");
        }
    }, [])

    


    const OnConfirmButtonClicks = () => {
        if(nsaUnauthToAuthFlowEnableFFlag)
        {Cookies.remove('NsaUnAuthSessionId');
        dispatch(setUnauthToAuth(false))
        }
        dispatch(saveDeviceDetails(data?.body?.data?.devicesAndPlans?.deviceDetails));
        dispatchDeviceAndPlansImpression(deviceSelectionData?.deviceDetails,confirmedPlanData,failedUpdateCartData)
        dispatch(setConfirmationPage(true));
        navigate("/itpconfirmation");
    }

    const openEditTripLink = (ctaUrl) => {
       if(previousLocation?.state === '/itptraveldates'){
            navigate(-2, {replace:true})            
        }else{
            navigate(ctaUrl,{replace:true})
        }
    }

    const checkRecurringPlan = () => {
        if(confirmedPlanData.find((plan) => plan?.recurringPlan === true)){
            return true;
        } else {
            return false;
        }
    }

    return (
        <DevicePageMain id="device_page">
            {(isSuccess && deviceSelectionData) ?
                (<>
                    {deviceSelectionData?.notification &&
                        <Notification
                            type={deviceSelectionData?.notification?.type}
                            title={deviceSelectionData?.notification?.text}
                            fullBleed={true}
                            bold={false}
                            inline={false}
                            disableFocus={true}
                            hideCloseButton={false}
                        />}
                    <Space pt={48} />
                    <DevicePage >
                        <Header data-testid="pageTitleId" pageTitle={deviceSelectionData?.pageTitle} progressData={deviceSelectionData?.progressBar}></Header>
                        <Title size="large" ref= {yourTripRef} onClick={triggerClick}>{deviceSelectionData?.heading}</Title>
                        <Space />
                        <Body size="large">{deviceSelectionData?.travelDates}</Body>
                        <StyledBlock><Body size="large">{deviceSelectionData?.travelLabel}</Body>
                        {deviceSelectionData?.travelingCountries && nsaUnauthToAuthFlowEnableFFlag && <Body size="large" bold={true}>{addSpace(deviceSelectionData?.travelingCountries, ',')}</Body>}</StyledBlock>
                        <Space />
                        <TextLink onClick={() => { openEditTripLink(deviceSelectionData?.editTripCtaList[0].ctaUrl) }}>{deviceSelectionData?.editTripCtaLabel}</TextLink>
                        <Space pt={36} />
                        {deviceSelectionData?.payGoOnly && deviceSelectionData?.payGoOnlyNotificationText &&
                            <Notification
                                type="error"
                                title={convertStringToElements(deviceSelectionData?.payGoOnlyNotificationText)}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                                hideCloseButton={true}
                            />}

                        {deviceSelectionData?.mixedPayGo && deviceSelectionData?.mixedPayGoNotificationText &&
                            <Notification
                                type="warning"
                                title={convertStringToElements(deviceSelectionData?.mixedPayGoNotificationText)}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                                hideCloseButton={true}
                            />}
                        <Space pt={24} />
                        <Line type="secondary" />
                        <Space pt={24} />
                        <Title size="large">{deviceSelectionData?.tripSubHeading}</Title>
                        <Space pt={24} />
                        {deviceSelectionData?.discountedCustomer && <><Body size="large">{deviceSelectionData?.discountedPlans}</Body><Space pt={24}/></>}                        
                        {deviceSelectionData?.subHeadingText &&
                            <StyledTextDiv>
                                <TravelPass
                                    color="#0089EC"
                                    size="45px"
                                />
                                <Body size="medium">{deviceSelectionData?.subHeadingText}</Body>
                            </StyledTextDiv>}
                        {deviceSelectionData?.onlyAirPlane && deviceSelectionData?.airplaneNotificationText &&
                            <Notification
                                type="error"
                                hideCloseButton="true"
                                title={deviceSelectionData?.airplaneNotificationText}
                                fullBleed={false}
                                inline={false}
                                disableFocus={true}
                            />}
                        
                        <Space pt={36} />
                        <StyledRow>
                            {deviceSelectionData?.deviceDetails?.map((deviceDetailInfo, i) => (
                                <DeviceDetails
                                    deviceDetailInfo={deviceDetailInfo}
                                    onlyAirPlane={deviceSelectionData?.onlyAirPlane}
                                    flightReviewDetailObject={flightReviewDetailObject}
                                    domesticTooltip={deviceSelectionData?.domesticTooltip}
                                    pendingOrderObject={pendingOrderObject}
                                >
                                </DeviceDetails>
                            ))}
                            {deviceSelectionData?.deviceDetails?.map((deviceDetailInfo, i) => (
                                <AdvisoryDetails
                                    deviceDetailInfo={deviceDetailInfo}
                                    travelReadynotification={deviceSelectionData?.travelReadynotification}>
                                </AdvisoryDetails>
                            ))}
                            {deviceSelectionData?.connectedDevicesAvailable &&
                                < ConnectedDeviceDetails
                                    connectedDevices={deviceSelectionData?.connectedDevices}></ConnectedDeviceDetails>}
                        </StyledRow>
                        <Space pt={28} />
                        {wrapUpData && nsaItpAcssPosFlowEnablementFFlag && (isACSS || isPOS) && <WrapUp wrapUpData = {wrapUpData}></WrapUp>}

                        {checkRecurringPlan() && <Billchange />}
                        <Space pt={24} />
                        <Footer ctaLabel={deviceSelectionData?.ctaList[0]?.ctaLabel} handleButtonChange={OnConfirmButtonClicks} disabled={deviceSelectionData?.confirmDisable} btn= {true}></Footer>
                        {nsaItpAcssPosFlowEnablementFFlag && (isACSS || isPOS) &&<Reptool deviceSelectionData={deviceSelectionData?.deviceDetails}></Reptool>}

                    </DevicePage>

                    {/* {showPaygoRatesModal &&
                        <PaygoRatesModal
                            setPaygoRatesModal={setPaygoRateModal}
                        />
                    } */}
                   
                </>
                )
                : (error && <ErrorPage errorDetails={error?.data} />)

            }
            {isLoading && <FullPageLoader />}
        </DevicePageMain>
    )
} 